/**
 * @desc 列表
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.ResponseDto<ObjectMap>;
export function request(
  params: API.basics.certBattery.list.Params,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/certBattery/list`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
